import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';  // Add this line if it's not already there
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);